// extracted by mini-css-extract-plugin
export default {"statics":"Statics_statics__Z4UTA","active":"Statics_active__nabKM"};